import { render, staticRenderFns } from "./index.vue?vue&type=template&id=b2b4c704&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=b2b4c704&prod&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=b2b4c704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b4c704",
  null
  
)

export default component.exports